function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, Ref, ElementType, MouseEventHandler, CSSProperties } from 'react';
import cn from 'classnames';
import { Link } from '../Link';
import { Icon } from '../Icon';
import { AddressButtonIcon } from './ButtonIcon/AddressButtonIcon';
require("./Address.css");
var styles = {
  "Root": "Address-module-Root_FQ6",
  "DeliveryIcon": "Address-module-DeliveryIcon_1pt",
  "Label": "Address-module-Label_3uG",
  "Delivery": "Address-module-Delivery_3ap"
};
export const Address = ({
  address,
  addressPickLabel = 'Укажите адрес',
  className,
  controlRef,
  deliveryButton,
  deliveryText,
  hasDeliveryIcon,
  innerRef,
  isOpen = false,
  onClickAddress,
  onClickDelivery,
  style = {},
  tag = 'div',
  ...props
}) => {
  const Component = tag;
  return /*#__PURE__*/React.createElement(Component, _extends({
    style: style,
    className: cn(styles.Root, className),
    ref: innerRef || controlRef
  }, props), /*#__PURE__*/React.createElement("div", {
    className: styles.Label
  }, Boolean(address) && address, !address && /*#__PURE__*/React.createElement(Link, {
    tag: "span",
    onClick: onClickAddress,
    role: "button",
    variant: "default"
  }, addressPickLabel), /*#__PURE__*/React.createElement(AddressButtonIcon, {
    onPointerDown: onClickAddress,
    isOpen: isOpen,
    "aria-label": addressPickLabel
  })), Boolean(deliveryText) && /*#__PURE__*/React.createElement("div", {
    className: styles.Delivery
  }, /*#__PURE__*/React.createElement(React.Fragment, null, hasDeliveryIcon && /*#__PURE__*/React.createElement(Icon, {
    name: 'lightning',
    className: styles.DeliveryIcon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.DeliveryText
  }, deliveryText, deliveryButton && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement(Link, {
    tag: "span",
    onClick: onClickDelivery,
    role: "button",
    tabIndex: 0,
    variant: "default"
  }, deliveryButton))))));
};
if (process.env.NODE_ENV !== 'production') {
  Address.displayName = 'Address';
}